import React, { useEffect, useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react';
import { Menu, PageHeader, Layout, Spin, Breadcrumb, Button, Tag } from 'antd';
import * as AntdIcons from '@ant-design/icons';
import { langOptions, Context } from '../../defaults';
import { getUserTasks, getLoggedUser } from '../../actions';
import style from './index.module.css';
import jwt from 'jwt-decode';
import { ConfigProvider } from 'antd';
import kkKZ from 'antd/lib/locale-provider/kk_KZ';
import ruRU from 'antd/lib/locale-provider/ru_RU';

import './index.css';
import { UserOutlined } from '@ant-design/icons';

export const CustomLayout = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const { Content, Footer, Sider } = Layout;
  const [current, setCurrent] = useState(location.pathname);
  const [currentUser, setCurrentUser] = useState('');
  const {
    dictionary,
    language,
    loading,
    links,
    setLinks,
    setLanguage,
    token,
    setToken,
  } = useContext(Context);

  const navigate = (to) => {
    setCurrent(to);
    history.push(to);
  };

  const logOut = () => {
    setToken(undefined);
    localStorage.removeItem('token');
    sessionStorage.clear();
    history.push('/login');
  };

  useEffect(() => {
    const t = localStorage.getItem('token');
    if (t) {
      setToken(t);
      const persistedToken = jwt(t);
      if (persistedToken && persistedToken['nameid']) {
        getUserTasks(persistedToken['nameid'])
          .then((res) => res.json())
          .then((res) => {
            setLinks(res);
          });
        if (!(Date.now() >= persistedToken.exp * 1000)) {
          getLoggedUser()
            .then((res) => setCurrentUser(res.data))
            .catch(() => setToken(''));
        }
      }
    }
  }, [setLinks, setToken, token]);

  return (
    <div>
      <ConfigProvider locale={language === 'kaz' ? kkKZ : ruRU}>
        <Layout>
          <Menu theme="dark">
            <PageHeader
              className="site-page-header"
              title="Amanat studies"
              extra={[
                <span key="loggedUser">
                  {token && (
                    <Tag color="#108ee9">
                      <UserOutlined /> {currentUser[1]} ({currentUser[0]})
                    </Tag>
                  )}
                </span>,
                <Dropdown
                  key="language"
                  inline
                  options={langOptions}
                  defaultValue={language}
                  onChange={(e, { value }) => {
                    setLanguage(value);
                    localStorage.setItem('language', value);
                  }}
                />,
                <span key="login">
                  {!token && (
                    <Button
                      type="dashed"
                      icon={<AntdIcons.LoginOutlined />}
                      shape="circle"
                      onClick={() => {
                        history.push('/login');
                      }}
                    />
                  )}
                </span>,
              ]}
            />
          </Menu>
          <Content style={{ padding: '0 50px' }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>{dictionary?.HomePage[language]}</Breadcrumb.Item>
              {current &&
                links &&
                links.length > 0 &&
                links.filter((m) => m.name === current).length > 0 && (
                  <Breadcrumb.Item>
                    {links.filter((m) => m.name === current)[0][language]}
                  </Breadcrumb.Item>
                )}
            </Breadcrumb>
            <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
              {token && (
                <Sider className="site-layout-background" width={300}>
                  <Menu selectedKeys={[current]} className={style.navBar} mode="inline">
                    <Menu.Item
                      key="/"
                      onClick={() => {
                        navigate('/');
                      }}
                      icon={<AntdIcons.AppstoreOutlined />}>
                      {dictionary?.HomePage[language]}
                    </Menu.Item>
                    {links &&
                      links.map((el, i) => {
                        if (i < 5) {
                          const ElementIcon = AntdIcons[el.iconName];
                          return (
                            <Menu.Item
                              key={el.name}
                              onClick={() => {
                                navigate(el.name);
                              }}
                              icon={<ElementIcon />}>
                              {el[language]}
                            </Menu.Item>
                          );
                        }
                      })}
                    {links && links.length > 2 && (
                      <Menu.SubMenu
                        key="SubMenu"
                        icon={<AntdIcons.SettingOutlined />}
                        title={`${dictionary?.More[language]}`}>
                        {links.map((el, i) => {
                          if (i >= 5) {
                            const ElementIcon = AntdIcons[el.iconName];
                            return (
                              <Menu.Item
                                key={el.name}
                                onClick={() => navigate(el.name)}
                                icon={<ElementIcon />}>
                                {el[language]}
                              </Menu.Item>
                            );
                          }
                        })}
                      </Menu.SubMenu>
                    )}
                    {token && (
                      <Menu.Item onClick={logOut} icon={<AntdIcons.LogoutOutlined />}>
                        {dictionary?.LogOut[language]}
                      </Menu.Item>
                    )}
                  </Menu>
                </Sider>
              )}
              <Content style={{ padding: '0 24px', minHeight: 500 }}>
                <Spin tip={`${dictionary ? dictionary?.Loading[language] : ''}`} spinning={loading}>
                  {children}
                </Spin>
              </Content>
            </Layout>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            <a key="refPyvela" href="http://pyvela.kz/">
              Pyvela ЕНТ
            </a>
          </Footer>
        </Layout>
      </ConfigProvider>
    </div>
  );
};
